import React from 'react';

import { PageTitle } from '@/modules/CarsStock/components/common.styles';
import { useCarsStockSeo } from '@/modules/CarsStock/components/common.hooks';

import { TitleProps } from './types';

function Title({ carsType }: TitleProps) {
  const { h1 } = useCarsStockSeo();

  const title = h1
    ? h1
    : (carsType === 'new' && 'Новые автомобили') ||
      (carsType === 'amp' && 'Автомобили с пробегом') ||
      (carsType === 'electric' && 'Новые электромобили') ||
      (carsType === 'commercial' && 'Коммерческие автомобили') ||
      (carsType === 'hybrid' && 'Гибридные автомобили') ||
      'Все авто';

  return <PageTitle>{title}</PageTitle>;
}

export default Title;
